import { Type } from 'class-transformer'

import MessageEditorWithMediaData from '../../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/types'
import { ActionNodeActionTypesFactory } from '../../../Action/logic/ActionNode'
import ActionNodeActions
  from '../../../Action/logic/Actions'
import ActionNodeAction from '../../../Action/logic/Actions'
import { MessageNodeActionTypes } from '../types'
import BaseSendMessageAction from './BaseAction'

export default class UserInputAction extends BaseSendMessageAction {
  declare type: MessageNodeActionTypes.UserInput
  property_index!: number | null
  pattern?: string
  negate!: boolean
  fail_try_max_count!: number
  fail_variants!: Array<MessageEditorWithMediaData>
  inactive_action!: {
    output: number
    time: number
  }
  fail_output?: number
  @Type(() => ActionNodeAction, {
    keepDiscriminatorProperty: true,
    discriminator: {
      property: 'type',
      subTypes: ActionNodeActionTypesFactory.ModelsFactories
    }
  })
  actions!: Array<ActionNodeAction>
}
